export * from './IconBold';
